import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/reportesbi/operaciones-sin-internet',
  alias: ['/sistema/reportesbi/operaciones-sin-internet/Index'],
  documento: 'reportesbi',
  acceso: 'sesion',
  filas: ['123'],
  cita: 'Areas/ReportesBI/Controllers/OperacionesSinRedController.cs:33',
} satisfies RutaProd;
